import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cad24c0a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "logistics-box"
};
const _hoisted_2 = {
  key: 0,
  class: "tips"
};
const _hoisted_3 = {
  key: 1,
  class: "dialog"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-close"
})], -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "cont"
};
const _hoisted_7 = {
  key: 0,
  class: "used_logo"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  key: 0,
  class: "cont_item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "卖家备注:", -1));
const _hoisted_12 = {
  class: "cont"
};
const _hoisted_13 = {
  key: 1,
  class: "cont_item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "虚拟回报", -1));
const _hoisted_15 = {
  class: "cont"
};
const _hoisted_16 = ["onClick", "copyData", "onUpdate:modelValue"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-copy"
})])], -1));
const _hoisted_18 = {
  key: 0,
  class: "cont_item",
  style: {
    "border-bottom": "0.013333rem solid #dee0e1"
  }
};
const _hoisted_19 = ["onClick", "copyData", "onUpdate:modelValue"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-transporttruck"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-copy"
})])], -1));
const _hoisted_22 = {
  key: 1,
  class: "cont_item"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "info"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-transporttruck"
}, null, -1));
const _hoisted_26 = {
  class: "time"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-next"
})], -1));
const _hoisted_28 = {
  key: 2,
  class: "img-box"
};
const _hoisted_29 = ["onClick", "src"];
const _hoisted_30 = {
  key: 0,
  class: "imgnum"
};
const _hoisted_31 = {
  key: 3,
  class: "qrcode"
};
const _hoisted_32 = {
  key: 0,
  class: "cont_item"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "验证码:", -1));
const _hoisted_34 = {
  class: "cont"
};
const _hoisted_35 = ["onClick", "copyData", "onUpdate:modelValue"];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-copy"
})])], -1));
const _hoisted_37 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['img'])
};
const _hoisted_38 = ["onClick", "src"];
const _hoisted_39 = {
  key: 0,
  class: "used"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-amplification"
})]), /*#__PURE__*/_createTextVNode(" 戳二维码，放大查看 ")], -1));
const _hoisted_41 = ["onClick"];
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "music-title"
}, "音频合集", -1));
const _hoisted_43 = {
  class: "music-box"
};
const _hoisted_44 = {
  class: "img"
};
const _hoisted_45 = ["src"];
const _hoisted_46 = {
  class: "content"
};
const _hoisted_47 = {
  class: "name"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "get-details"
}, [/*#__PURE__*/_createTextVNode(" 查看合集 "), /*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-next"
})])], -1));
const _hoisted_49 = ["onClick"];
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nft-title"
}, "数字藏品", -1));
const _hoisted_51 = {
  class: "nft-box"
};
const _hoisted_52 = {
  class: "img"
};
const _hoisted_53 = ["src"];
const _hoisted_54 = {
  class: "content"
};
const _hoisted_55 = {
  class: "name"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "get-details"
}, [/*#__PURE__*/_createTextVNode(" 点击查看 "), /*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-next"
})])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.top_title ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($setup.top_title), 1)) : _createCommentVNode("", true), $data.dialog_show ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", {
    class: "close",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $data.dialog_show = false, ["stop"]))
  }, _hoisted_5), _createElementVNode("div", _hoisted_6, [$data.dialog_used == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("img", {
    src: $data.dialog_src,
    class: ""
  }, null, 8, _hoisted_8)])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['logistics_item', 'logistics_item_' + item.post_type]),
      key: index
    }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("strong", null, _toDisplayString(item.post_title), 1), _createElementVNode("em", null, _toDisplayString(item.post_time), 1)]), item.post_msg ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("p", null, _toDisplayString(item.post_msg), 1)])])) : _createCommentVNode("", true), item.post_type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("input", {
      type: "input",
      onClick: _withModifiers($event => $options.copy(index), ["stop"]),
      ref_for: true,
      ref: "copyboard",
      copyData: item.virtual_info.game_code,
      "onUpdate:modelValue": $event => item.virtual_info.game_code = $event
    }, null, 8, _hoisted_16), [[_vModelText, item.virtual_info.game_code]]), _createElementVNode("p", null, [_createTextVNode(_toDisplayString(item.virtual_info.game_code) + " ", 1), _hoisted_17])])])) : _createCommentVNode("", true), item.post_type == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [item.mail_info ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", {
      class: "center borderBottom",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [_withDirectives(_createElementVNode("input", {
      type: "input",
      onClick: _withModifiers($event => $options.copy(index), ["stop"]),
      ref_for: true,
      ref: "copyboard",
      copyData: item.mail_info.express_no,
      "onUpdate:modelValue": $event => item.mail_info.express_no = $event
    }, null, 8, _hoisted_19), [[_vModelText, item.mail_info.express_no]]), _createElementVNode("p", null, [_hoisted_20, _createTextVNode(" " + _toDisplayString(item.mail_info.express_name) + ": " + _toDisplayString(item.mail_info.express_no) + " ", 1), _hoisted_21])])])) : _createCommentVNode("", true), item.logistics_info ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", {
      class: "center borderBottom",
      onClick: _withModifiers($event => $options.goDetail(item.mail_info.express_name, item.mail_info.express_no), ["stop"])
    }, [_createElementVNode("input", {
      type: "hidden",
      ref_for: true,
      ref: "copyboard"
    }, null, 512), _createElementVNode("p", _hoisted_24, [_hoisted_25, _createTextVNode(" " + _toDisplayString(item.logistics_info.status), 1)]), _createElementVNode("div", _hoisted_26, _toDisplayString(item.logistics_info.time), 1), _hoisted_27], 8, _hoisted_23)])) : _createCommentVNode("", true), item.entry_list ? (_openBlock(), _createElementBlock("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.entry_list, (e, r) => {
      return _openBlock(), _createElementBlock("div", {
        class: "img",
        key: r
      }, [_createElementVNode("img", {
        onClick: _withModifiers($event => $options.dialog(index), ["stop"]),
        src: e.show_img
      }, null, 8, _hoisted_29), e.num > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_30, "×" + _toDisplayString(e.num), 1)) : _createCommentVNode("", true)]);
    }), 128))])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), item.post_type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [item.qr_info.qrcode ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_withDirectives(_createElementVNode("input", {
      type: "input",
      onClick: _withModifiers($event => $options.copy(index), ["stop"]),
      ref_for: true,
      ref: "copyboard",
      copyData: item.qr_info.qrcode,
      "onUpdate:modelValue": $event => item.qr_info.qrcode = $event
    }, null, 8, _hoisted_35), [[_vModelText, item.qr_info.qrcode]]), _createElementVNode("p", null, [_createTextVNode(_toDisplayString(item.qr_info.qrcode) + " ", 1), _hoisted_36])])])) : _createCommentVNode("", true), item.qr_info.qrcode_pic ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("img", {
      onClick: _withModifiers($event => $options.dialog(index), ["stop"]),
      src: item.qr_info.qrcode_pic
    }, null, 8, _hoisted_38), item.qr_info.qr_use == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_39)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _hoisted_40])) : _createCommentVNode("", true), item.post_type == 5 ? (_openBlock(), _createElementBlock("div", {
      key: 4,
      class: "music",
      onClick: $event => $options.jumpMusic(item)
    }, [_hoisted_42, _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("img", {
      src: item.music_info.music_img ? item.music_info.music_img : $data.placeholder,
      alt: ""
    }, null, 8, _hoisted_45)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(item.music_info.music_name), 1), _hoisted_48])])], 8, _hoisted_41)) : _createCommentVNode("", true), item.post_type == 6 ? (_openBlock(), _createElementBlock("div", {
      key: 5,
      class: "nft",
      onClick: $event => $options.jumpNft(item)
    }, [_hoisted_50, _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("img", {
      src: item.nft_info.nft_img_url ? item.nft_info.nft_img_url : $data.placeholder,
      alt: ""
    }, null, 8, _hoisted_53)]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString(item.nft_info.nft_title), 1), _hoisted_56])])], 8, _hoisted_49)) : _createCommentVNode("", true)], 2);
  }), 128))]);
}